export const paramsToQueryString = (params?: { [name: string]: number | string }) =>
  params
    ? `?${Object.keys(params)
        .map((key: string) => key + '=' + params[key])
        .join('&')}`
    : '';
